<template>
  <v-container
    class="px-4"
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        lg="6"
      >
        <subscription-info />
      </v-col>
      <v-col
        cols="12"
        lg="6"
      >
        <card-info />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SubscriptionInfo from '@/components/billing/SubscriptionInfo.vue'
  import CardInfo from '@/components/billing/CardInfo.vue'

  export default {
    name: 'Billing',
    components: { SubscriptionInfo, CardInfo },
    computed: {
      ...mapGetters({
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
        canUpdateBilling: 'Billing/currentOrgBillingEnabled',
      }),
    },
    watch: {
      currentSelectedOrg () {
        this.handleOrgUpdate()
      },
    },
    created () {
      this.handleOrgUpdate()
    },
    methods: {
      handleOrgUpdate () {
        if (!this.canUpdateBilling) {
          this.$router.push('/')
        }
      },
    },
  }
</script>
